import domReady from '@wordpress/dom-ready';

domReady(() => {
  const videoModal = document.getElementById('videoModal');

  if (videoModal) {
    const iframe = videoModal.querySelector('iframe');
    const video = videoModal.querySelector('video');

    videoModal.addEventListener('show.bs.modal', () => {
      if (iframe && iframe.dataset.src) {
        iframe.src = iframe.dataset.src;
      }
    });

    videoModal.addEventListener('hidden.bs.modal', () => {
      if (videoModal.contains(videoModal.ownerDocument.activeElement)) {
        videoModal.ownerDocument.activeElement.blur();
      }

      if (iframe) {
        iframe.src = '';
      }

      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    });
  }

  // Select all play buttons
  const playButtons = document.querySelectorAll('.play-video');

  // Add click event listener to each play button
  playButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      // Hide the clicked button
      this.style.display = 'none';

      // Get the parent .vcc--video container of the clicked button
      const videoContainer = this.closest('.vcc--video');

      // Check if it's a remote video or a local video within the clicked container
      const isRemoteVideo = videoContainer.querySelector('iframe');
      const localVideo = videoContainer.querySelector('video');

      if (isRemoteVideo) {
        // For remote videos (YouTube), update the src to autoplay
        const iframeSrc = isRemoteVideo.src;
        isRemoteVideo.src =
          iframeSrc + (iframeSrc.includes('?') ? '&' : '?') + 'autoplay=1';
      } else if (localVideo) {
        // For local videos, play the video
        localVideo.play();
      }
    });
  });
});
